
import { Message } from 'element-ui'
import Vue from 'vue'
import axios from 'axios'


// axios.defaults.baseURL = 'http://10.168.1.81:9095/cloudApi'
axios.defaults.baseURL = 'https://recycle.myzhanyun.com/cloudApi/'
/**
 *
 * GET 方法
 * @export function (param) {  }
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 * @returns Promise
 */
export function httpGet (url, params) {
  return new Promise((resolve, reject) => {
    // axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL
      // axios.defaults.baseURL = 'http://10.168.1.81:9095/cloudApi'
      // axios.defaults.baseURL = 'http://10.168.1.94:8080/cloudApi'

    axios.defaults.headers.common['token'] = localStorage.token
    axios.get(url, {
      params: params,
    })
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        console.warn(err, 'WARN')
        reject(err)
      })
  })
}

/**
 *
 * POST 方法
 * @export function (param) {  }
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 * @returns Promise
 */
export function httpPost (url, params) {
  return new Promise((resolve, reject) => {
    // console.log(process.env.VUE_APP_FLAG,'110')
    // console.log(localStorage.token,'111' )
    // axios.defaults.baseURL = 'http://121.43.63.119:9095/cloudApi'
    // axios.defaults.baseURL = 'http://10.168.1.81:9095/cloudApi'
    if(localStorage.token) {
      axios.defaults.headers.common['token'] = localStorage.token
    } else {

      axios.defaults.headers.common['token'] = 'baa81f04281e58e3d428cf54f0a94f8c'
    }
    axios.post(url, params)
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        if (err === undefined || err.__CANCEL__) {
          return false
        }
        Message.error({
          title: '错误',
          message: err
        })
        reject(err)
      })
  })
}

export function httpNoticePost (url, params) {
  return new Promise((resolve, reject) => {
    // axios.defaults.baseURL = 'http://10.168.1.81:9095/cloudApi'
    axios.post(url, params)
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        if (err === undefined || err.__CANCEL__) {
          return
        }
        Message.error({
          title: '错误',
          message: err
        })
      })
  })
}



// WEBPACK FOOTER //
// ./src/api/request/index.js